<template>
  <div class="shop-menu-item" style="cursor: pointer" @click="clickItem">
    <div v-if="isList" class="list-view">
      <div v-if="isNewCategory" class="new-category">
        <span v-if="o.out_of_stock">{{ $t("commerce.out-of-stock") }}</span>
        <span v-else>{{ o.category }}</span>
      </div>

      <i v-show="o.special" class="fa fa-star special" @click="infoToast('Special!')" />
      <div class="card" :class="{ 'menu-item': qty }" :style="specialStyle(o)">
        <fade-transition>
          <div v-if="qty" class="item-quantity-wrapper">
            <div class="item-quantity" @click="showBasket = true">
              {{ qty }}
            </div>
          </div>
        </fade-transition>

        <fade-transition>
          <div v-if="animate" class="animation" :class="animate">
            <span v-html="msg" />
          </div>
        </fade-transition>

        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure v-if="o.pic || !o.color" class="image" @click="$emit('imgClick', o)">
                <img v-webp="pic(o)" @error="defaultImg" :style="imgStyle(o)"
                  :class="{ 'oos-opacity': o.out_of_stock, 'contain-img': o.contain_image }" />
              </figure>
              <figure v-else class="no-img" :style="'background-color: ' + o.color" />

              <div v-show="o.discount" class="percent-off">
                −{{ prettyDiscount(o) }}
              </div>
              <div class="status-banner">
                <span v-if="o.out_of_stock" class="tag has-text-weight-medium has-text-grey">
                  {{ $t("commerce.out-of-stock") }}
                </span>
                <span v-else-if="isMembersOnly(o)" class="tag has-text-weight-medium has-text-link">
                  <i v-if="member" class="fa fa-lock-open" />
                  <i v-else class="fa fa-lock" />&nbsp;Members Only
                </span>
                <span v-else-if="o.flash_deal" class="tag is-warning has-text-weight-medium">
                  <i class="fa fa-bolt" />&nbsp;Flash Deal
                </span>
                <span v-else-if="o.free_gift" class="tag is-danger has-text-weight-medium">
                  <i class="fa fa-gift" />&nbsp;Free Gift
                </span>
              </div>
            </div>
            <div class="media-content" style="margin-right: -10px">
              <!-- @click="clamped = !clamped" -->
              <div class="text" :class="{ rtl: isRTL }">
                <p v-if="tags(o).length" style="line-height: 1.3em; margin-bottom: 0px">
                  <span v-for="t in tags(o)" :key="t" class="tag is-capitalized" style="margin-right: 4px">
                    <span v-if="t.startsWith('*')">
                      <i class="far fa-clock" />
                      {{ t.replace("*", "") }}
                    </span>
                    <span v-else>{{ t }}</span>
                  </span>
                </p>
                <p class="subtitle has-text-weight-medium" :class="{ 'has-text-grey': o.out_of_stock }">
                  <!-- margin-top here is needed for thai letters that extend upwards like รถรั้ว !!! -->
                  {{ itemName(o) }}
                </p>
                <p class="description" :class="{ clamp: clamped }">
                  <span>{{ itemDescription(o) }}</span>
                </p>
              </div>
              <div class="price" :class="{ 'oos-opacity': o.out_of_stock }">
                <span class="tag is-medium">
                  <span v-if="o.discount">
                    <span class="normal-price">
                      {{ currency }}{{ o.price }}
                    </span>
                    <span class="has-text-danger has-text-weight-medium">
                      {{ currency }}{{ discountedPrice(o) }}
                    </span>
                    <span v-if="isSOL" class="total-sol">{{ priceSOL(o) }} SOL</span>
                  </span>
                  <span v-else>
                    <span v-if="o.price > 0">{{ currency }}{{ o.price }}</span>
                    <span v-else-if="o.free_gift" class="has-text-danger">Free Gift over {{ currency }}{{ o.free_gift
                    }}</span>
                    <span v-else>From {{ currency }}{{ o.price_from || "0" }}</span>
                    <span v-if="isSOL" class="total-sol">{{ priceSOL(o) }} SOL</span></span>
                  <span v-if="o.by_weight" class="has-text-grey has-text-weight-medium">{{ translateByWeight(o.by_weight)
                  }}</span>
                </span>

                <span v-if="o.options && o.options.length" class="tag is-white" style="margin-left: 2px" @click="add(o)">
                  <!-- <i class="fa fa-ellipsis-h fa-lg has-text-grey" /> -->
                  <i class="fa fa-ellipsis-v" />
                </span>
                <!-- <span v-if="o.vatable" class="new-vat">+VAT</span> -->
              </div>
              <div v-if="o.vatable" class="vat">+VAT</div>
            </div>
            <div class="out-of-stock">
              <!-- <span
                v-if="o.out_of_stock"
                class="tag is-medium has-text-weight-medium has-text-grey"
              >
                {{ $t("commerce.out-of-stock") }}
              </span>
              <span
                v-else-if="isMembersOnly(o)"
                class="tag is-medium has-text-weight-medium has-text-link"
              >
                <i class="fa fa-user-lock" />&nbsp;Members Only
              </span> -->
              <!-- <span v-else> -->
              <!-- <span v-else-if="qty"> -->
              <span v-if="qty">
                <span class="icon is-medium" style="margin-right: 4px" @click.stop="remove(o)">
                  <i class="fa fa-minus-circle fa-2x has-text-warning" />
                </span>
                <span class="icon is-medium" @click.stop="add(o)">
                  <i class="fa fa-plus-circle fa-2x" :class="{ 'has-text-info': qty }" />
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ---------------------------------------------------------------------- -->

    <!-- <div v-else class="grid"> -->
    <div v-else>
      <!-- <div v-if="isNewCategory && o.category" class="list-view">
        <div class="new-category">
          <p v-if="o.out_of_stock">{{ $t("commerce.out-of-stock") }}</p>
          <p v-else>{{ o.category }}</p>
        </div>
      </div> -->
      <div class="grid">
        <div class="card" :class="{ instagram: instagram }" :style="specialStyle(o)">
          <i v-show="o.special" class="fa fa-star special" @click="infoToast('Special!')" />

          <div v-if="isNewCategory && o.category && !o.out_of_stock" class="new-category no-scrollbar">
            {{ o.category }}
          </div>

          <fade-transition>
            <div v-if="animate" class="animation" :class="animate">
              <p v-html="msg" />
            </div>
          </fade-transition>

          <div class="card-image">
            <!-- <figure class="image is-4by3"> -->
            <figure v-if="o.pic || !o.color" class="image">
              <img v-webp="pic(o)" @error="defaultImg" :style="imgStyle(o)" :class="{ 'oos-opacity': o.out_of_stock }" />
              <p class="clamp gradient item-name">
                <span class="shadow">{{ itemName(o) }}</span>
              </p>
            </figure>
            <figure v-else class="no-img" :style="'background-color: ' + o.color">
              <p class="clamp gradient item-name">
                <span class="shadow">{{ itemName(o) }}</span>
              </p>
            </figure>
            <div v-show="o.discount" class="percent-off">
              −{{ prettyDiscount(o) }}
            </div>
            <div class="status-banner">
              <span v-if="o.out_of_stock" class="tag is-medium has-text-weight-medium has-text-grey">
                {{ $t("commerce.out-of-stock") }}
              </span>
              <span v-else-if="qty" class="tag is-medium grid-qty" @click="showBasket = true">
                {{ qty }}
              </span>
              <span v-else-if="isMembersOnly(o)" class="tag is-medium has-text-weight-medium has-text-link">
                <i v-if="member" class="fa fa-lock-open" />
                <i v-else class="fa fa-lock" />&nbsp;Members Only
              </span>
              <span v-else-if="o.flash_deal" class="tag is-medium is-warning has-text-weight-medium">
                <i class="fa fa-bolt" />&nbsp;Flash Deal
              </span>
              <span v-else-if="o.free_gift" class="tag is-medium is-danger has-text-weight-medium">
                <i class="fa fa-gift" />&nbsp;Free Gift
              </span>
            </div>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <!-- <p class="has-text-weight-medium clamp" style="line-height: 1.4em">
                {{ itemName(o) }}
              </p> -->
                <!-- class="clamp" -->
                <p style="font-size: 0.85em" :class="{ clamp: clamped }">
                  <!-- @click="clamped = !clamped" -->
                  {{ itemDescription(o) }}
                </p>
              </div>
            </div>

            <div class="grid-gradient" />

            <div class="price has-text-left" :class="{ 'oos-opacity': o.out_of_stock }">
              <span class="tag is-medium">
                <span v-if="o.discount">
                  <span class="normal-price">
                    {{ currency }}{{ o.price }}
                  </span>
                  <span class="has-text-danger has-text-weight-medium">
                    {{ currency }}{{ discountedPrice(o) }}
                  </span>
                  <span v-if="isSOL" class="total-sol">{{ priceSOL(o) }} SOL</span>
                </span>
                <span v-else><span v-if="o.price > 0">{{ currency }}{{ o.price }}</span>
                  <span v-else-if="o.free_gift" class="has-text-danger">Free Gift over {{ currency }}{{ o.free_gift
                  }}</span>
                  <span v-else>From {{ currency }}{{ o.price_from || "0" }}</span>
                  <span v-if="isSOL" class="total-sol">{{ priceSOL(o) }} SOL</span></span>
                <span v-if="o.by_weight" class="has-text-grey has-text-weight-medium">{{ translateByWeight(o.by_weight)
                }}</span>
              </span>
              <span v-if="o.vatable" class="vat">+VAT</span>

              <span v-if="o.options && o.options.length">
                <i class="fa fa-ellipsis-v fa-sm" />
              </span>
            </div>

            <div class="grid-plus">
              <!-- <span
              v-if="o.out_of_stock || isMembersOnly(o)"
              class="icon is-medium"
              style="opacity: 0.2"
              @click="unavailableToast(o)"
            >
              <i class="fa fa-plus-circle fa-2x has-text-grey" />
            </span>
            <span v-else> -->
              <span v-if="!(o.out_of_stock || isMembersOnly(o)) && qty">
                <!-- v-if="qty" -->
                <span class="icon is-medium" style="margin-right: 4px" @click.stop="remove(o)">
                  <i class="fa fa-minus-circle fa-2x has-text-warning" />
                </span>
                <span class="icon is-medium" @click.stop="add(o)">
                  <i class="fa fa-plus-circle fa-2x" :class="{ 'has-text-info': qty }" />
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopMenuItem",
  components: {},
  props: {
    o: Object,
    qty: Number,
    lang: String,
    currency: String,
    previousCategory: String,
    isList: Boolean,
    member: Boolean,
    instagram: Boolean,
    country: String,
  },
  data() {
    return {
      clamped: true,
      animate: null, // add or remove
      msg: null,
      // showAddButton: false,
    };
  },
  computed: {
    isSOL() {
      return this.country === "pt";
    },
    isRTL() {
      // return true; // for testing
      return this.lang === "he";
    },
    isNewCategory() {
      // if (this.o.out_of_stock) return false;
      var cat = this.o.category;
      if (this.o.out_of_stock) cat = "Out of Stock";
      if (this.previousCategory === "first" && !cat) return false;
      if (this.previousCategory === "Specials") return false;
      return cat !== this.previousCategory;
    },
    translatedCategory() {
      var categoryKey = this.o.category;
      // need to pass in props: categories and lang
      // then do a lookup using o.category
      return categoryKey;
    },
    removeMsg() {
      var removed = this.$t("menu.removed-from-basket");
      return `<i class='fa fa-minus'></i>&nbsp;${removed}`;
    },
    addMsg() {
      var added = this.$t("menu.added-to-basket");
      return `<i class='fa fa-plus'></i>&nbsp;${added}`;
    },
  },
  methods: {
    clickItem() {
      // do something
      // this.showAddButton = true;
      this.add(this.o);
    },
    tags(item) {
      // if (item.tags && item.tags.length) console.log("tags", item);
      if (!item.tags) return [];
      var remove = ["member"]; // skip these, handled separately
      return item.tags.filter((t) => !remove.includes(t));
    },
    imgStyle(o) {
      if (!this.isMembersOnly(o)) return null;
      if (this.member) return null;
      return `filter: blur(2px); transform: scale(1.1);`;
    },
    prettyDiscount(o) {
      var diff = o.price - this.discountedPrice(o);
      if (diff > o.discount) return this.currency + diff;
      if (o.discount_type === "number") return this.currency + diff;
      return o.discount + "%";
    },
    priceSOL(o) {
      var price = this.discountedPrice(o);
      return this.convertEURtoSOLPretty(price);
    },
    priceVAT(o) {
      return o.price * 0.01;
    },
    unavailableToast(o) {
      if (o.out_of_stock) {
        this.infoToast("Item out of stock");
      } else if (this.isMembersOnly(o)) {
        this.infoToast("Members only item");
      }
    },
    add(o) {
      this.$emit("add", o);
      // this.msg = this.addMsg;
      // if (o.options && o.options.length) return; // skip animation if has options
      // this.animate = "add";
      // setTimeout(() => (this.animate = null), 500);
    },
    remove(o) {
      this.$emit("remove", o);
      this.msg = this.removeMsg;
      this.animate = "remove";
      setTimeout(() => (this.animate = null), 500);
    },
    forceAnimate(addRemove) {
      if (addRemove === "add") this.msg = this.addMsg;
      else this.msg = this.removeMsg;
      setTimeout(() => {
        this.animate = addRemove; // "add" or "remove" string
        setTimeout(() => (this.animate = null), 500);
      }, 100);
    },
    pic(o) {
      // if (!o.pic) return this.$store.state.menuItemPlaceholderPic;
      return o.pic || this.$store.state.menuItemPlaceholderPic;
    },
    defaultImg(e) {
      e.target.src = this.$store.state.menuItemPlaceholderPic;
    },
    specialStyle(item) {
      if (item.id && item.id.startsWith("~")) return `background-color:azure`;
      return null;
    },
    isMembersOnly(o) {
      if (!o.tags) return false;
      return o.tags.includes("member");
    },
    itemName(o) {
      if (o[this.lang]) {
        return o[this.lang].name;
      }
      return o.name;
    },
    itemDescription(o) {
      var txt = o.description;
      if (o[this.lang]) txt = o[this.lang].description;
      return txt;
      // if (!txt) return null;
      // return txt.trim();

      // if (o[this.lang]) {
      //   return o[this.lang].description;
      // }
      // return o.description;
    },
  },
};
</script>



<style scoped>
.card {
  box-shadow: 0 0 1px #ddd;
}

.list-view .card:hover {
  box-shadow: 0px 0px 1px 1px #209cee95 inset;
}

.grid .card:hover {
  box-shadow: 0px 0px 1px 1px #209cee95 inset;
  box-shadow: 0px 0px 1px 1px #209cee95;
}

.card-content {
  /* padding: 12px; */
  padding: 8px;
}

.tag {
  padding: 0 8px;
  margin-bottom: 0;
}

figure {
  overflow: hidden;
}

.contain-img {
  object-fit: contain !important;
}

img {
  /* margin: -3px; */
  border-radius: 2px;
  object-fit: cover;
  height: 110px;
  width: 110px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}

.no-img {
  border-radius: 2px;
  object-fit: cover;
  height: 110px;
  width: 110px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}

/* .menu-item::before,
.menu-item::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-color: transparent;
  border-style: solid;
}
.menu-item::after {
  border-width: 1.35em;
  border-right-color: hsl(171, 100%, 41%);
  border-top-color: hsl(171, 100%, 41%);
} */
.item-quantity {
  position: absolute;
  right: 6px;
  top: 0;
  z-index: 1;
  color: white;
  font-size: 1.2em;
  font-weight: 450;
  text-shadow: 1px 1px 1px #333;
}

.item-quantity-wrapper {
  /* background-color: hsl(171, 100%, 41%); */
  background-color: #209cee;
  height: 33px;
  width: 33px;
  position: absolute;
  right: 0;
  top: 0;
  border-bottom-left-radius: 100%;
  box-shadow: -1px 1px 2px rgba(0, 0, 0, 0.14);
}

.grid-qty {
  /* background-color: hsl(171, 100%, 41%); */
  background-color: #209cee;
  color: white;
  width: 100%;
  font-weight: 500;
  text-shadow: 1px 1px 1px #333;
  /* text-align: center !important; */
}

.media-left {
  margin-right: 12px;
}

.subtitle {
  font-size: 1.1em;
  margin-bottom: 0px;
  margin-top: 3px;
}

.percent-off {
  position: absolute;
  left: 84px;
  top: 2px;
  font-size: 10.5pt;
  font-weight: 450;
  color: white;
  line-height: 1.4;
  padding: 0px 2px;
  border: 1px dotted white;
  border-radius: 2px;
  background-color: #ff3860e8;
}

.special {
  position: absolute;
  left: 0px;
  padding: 3px;
  margin: 2px;
  z-index: 1;
  /* background-color: rgba(255, 217, 0, 0.8); */
  background-color: #3273dcae;
  color: rgb(255, 242, 0);
  /* border-radius: 50%; */
  border-radius: 2px;
  text-shadow: 1px 1px 3px rgba(0, 64, 255, 0.9);
}

.list-view .new-category {
  width: 100vw;
  overflow: hidden;
  text-align: left;
  padding: 10px;
  font-weight: 500;
  font-size: 1.2em;
  color: #888;
  line-height: 1em;
  margin-top: 2px;
  margin-left: 4px;
}

/* clamp ellipsis to 2 lines */
.clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding-right: 4px;
}

.description {
  /* min-height: 40px; */
  font-size: 0.9em;
  white-space: pre-wrap;
}

.animation {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  backdrop-filter: blur(2px);
}

.animation span {
  text-align: center;
  vertical-align: middle;
  line-height: 132px;
  font-size: 1.1em;
  font-weight: 450;
  color: grey;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 10px;
}

.add {
  background-color: rgba(18, 220, 18, 0.25);
}

.remove {
  background-color: rgba(241, 234, 104, 0.6);
}

.out-of-stock {
  position: absolute;
  /* bottom: 8px; */
  bottom: 12px;
  right: 12px;
}

.text {
  min-height: 65px;
}

/* grid view styles */
.grid {
  text-align: left;
  flex: 1;
  display: inline-flex;
  /* display: inline-flex; */
  /* flex-wrap: wrap; */
}

.grid .card {
  width: calc(50vw - 6px);
  max-width: 225px;
  /* will see 2 up to 450px width */
  /* height: 260px; */
  margin: 4px 3px;
  margin-bottom: 2px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  /* box-shadow: 0 0 1px grey; */
  /* border: initial; */
  box-shadow: initial;
}

.grid .new-category {
  /* height: 270px; */
  /* text-align: center; */
  /* vertical-align: middle; */
  /* line-height: 400px; */
  /* width: 231px; */
  position: absolute;
  left: -4px;
  top: 24px;
  z-index: 1;
  border-radius: 2px;

  white-space: nowrap;
  overflow: auto;
  display: inline-block;
  width: calc(50vw - 12px);
  max-width: 225px;

  /* background-color: #888;
  color: white; */

  /* background-color: whitesmoke;
  color: #999; */

  background-color: white;
  /* color: #333; */
  color: var(--link);

  /* overflow: hidden; */
  padding: 8px;
  font-weight: 500;
  font-size: 1.2em;

  line-height: 1em;
  box-shadow: 0 0 2px black;
}

.instagram {
  width: calc(100vw - 6px) !important;
  max-width: 450px !important;
}

.instagram img {
  height: auto !important;
}

.grid img {
  border-radius: 2px;
  box-shadow: 0px 0px;
  width: 100%;
  height: 190px;
}

.grid .no-img {
  border-radius: 2px;
  height: 190px;
  width: 100%;
  box-shadow: 0px 0px;
}

.grid .percent-off {
  float: right !important;
}

.grid .out-of-stock {
  position: relative !important;
  text-align: right;
  /* bottom: 8px; */
  /* bottom: 12px; */
  /* right: 12px; */
}

.grid .animation {
  display: block;
  text-align: center;
  /* vertical-align: middle; */
  /* line-height: 132px; */
  font-size: 0.9em;
  font-weight: 450;
  color: grey;
  width: 100%;
  /* background-color: rgba(255, 255, 255, 0.8); */
  /* padding: 10px; */
  /* border-radius: 10px; */
}

.grid .animation p {
  background-color: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 4px;
  position: fixed;
  /* margin-left: auto; */
  margin: auto 8px;
  width: calc(100% - 16px);
  top: 40px;
}

.grid .card-content {
  padding: 6px;
  padding-top: 2px;
  padding-bottom: 4px;
  /* height: 126px; */
  overflow: hidden;
}

.grid .special {
  margin: 0px;
}

.grid .percent-off {
  border-radius: 2px;
  position: absolute;
  left: auto;
  right: 0px;
  top: 0px;
}

.grid .media {
  /* border: 1px solid grey; */
  /* height: 52px; */
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 8px;
}

.grid p {
  min-height: 42px;
}

.grid p.clamp {
  height: 42px;
}

.grid .price {
  position: absolute;
  bottom: 4px;
  left: 4px;
}

.oos-opacity {
  opacity: 0.5;
}

.grid-plus {
  position: absolute;
  bottom: 2px;
  right: 4px;
}

/* .grid-gradient {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 0, 0, 0),
    rgb(255, 255, 255)
  );
} */
.status-banner {
  position: absolute;
  top: 93px;
  /* margin-left: -3px; */
  opacity: 0.8;
  /* width: 116px; */
  width: 110px;
}

.grid .status-banner {
  position: absolute;
  margin-top: -80px;
  /* margin-left: 0; */
  top: initial;
  opacity: 0.8;
  width: 100%;
}

.is-capitalized.tag {
  padding: 4px;
  color: rgb(255, 255, 255);
  background-color: #ccc;
  font-weight: 500;
  /* color: grey; */
  height: 1.5em;
}

.status-banner .tag {
  text-align: left;
  justify-content: initial;
}

.status-banner span {
  width: 100%;
  border-radius: 0px;
}

.normal-price {
  text-decoration: line-through;
  margin-right: 10px;
  font-size: 0.95em;
  color: grey;
}

/* .grid .out-of-stock {
  position: relative;
  float: right;
} */
.grid .item-name {
  line-height: 1.4em;
  position: absolute;
  bottom: 0px;
  left: 0px;
  color: white;
  font-weight: 550;
  padding-left: 6px;
  padding-bottom: 2px;
  height: 80px;
  width: 100%;
  display: flex;
  /* filter: drop-shadow(1px 1px 1px black); */
  overflow: hidden;
  text-overflow: ellipsis;
}

.grid .item-name span {
  align-self: flex-start;
}

.shadow {
  filter: drop-shadow(1px 1px 1px black);
}

.gradient {
  background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.4));
}

.link {
  border-bottom: 1px #ccc dotted;
}

.grid .fa-ellipsis-v {
  opacity: 0.1;
  position: absolute;
  margin-top: 9px;
  margin-left: 2px;
}

.fa-ellipsis-v {
  opacity: 0.1;
  margin-left: -10px;
}

.fa-plus-circle {
  /* color: #ccc; */
  color: #3273dc42;
}

.flash {
  text-shadow: 1px 0px 1px black;
  /* color: black; */
}

.total-sol {
  margin-left: 6px;
  background-color: var(--crypto-secondary);
  /* color: var(--crypto-primary); */
  padding: 0 4px;
  border-radius: 3px;
  /* font-weight: 500; */
  color: black;
  font-size: 0.85em;
}

.vat {
  font-size: 0.55em;
  padding: 2px;
  /* height: 0; */
  position: absolute;
}

.new-vat {
  font-size: 0.55em;
  padding: 2px;
  vertical-align: bottom;
}
</style>